// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__Z6aRR","options":"AnswerScale_options__3VG9c","selected":"AnswerScale_selected__3su1l"};